import React, { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getTextByDivision } from '../../common/commonFunction';
import NoCoupon1 from '../../common/images/nocoupon1.png';
import NoCoupon2 from '../../common/images/nocoupon2.png';
import { RedirectPharmacyLink } from '../../common/selectors';
import './NoCoupon.scss';
import '../PrescriptionFillsCount/PrescriptionFillsCount.scss';
import TermsLimitationsModal from '../IncentiveForm/TermsLimitationsModal/TermsLimitationsModal';

const NoCoupons = () => {
  const params = useLocation();
  const navigate = useNavigate();
  const RPharmaLink = useSelector(RedirectPharmacyLink);
  const [responseApi, setResponseApi] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  useEffect(() => {
    if (params && params.state && params.state.res) {
      setResponseApi(params?.state?.res);
    } else {
      navigate('/');
    }
  }, []);
  const escapeHandler = (e) => {
    if (e.key === 'Escape') {
      setModalOpen(false);
    }
  };
  useEffect(() => {
    document.addEventListener('keydown', escapeHandler, false);
    return () => {
      document.removeEventListener('keydown', escapeHandler, false);
    };
  }, []);

  const handleTermsLimitationsModal = () => {
    setModalOpen(true);
  };
  const handleTermsLimitationsClose = () => {
    setModalOpen(false);
  };

  return (
    <>
      <TermsLimitationsModal
        termsLimitationsModalShow={modalOpen}
        handleTermsLimitationsClose={handleTermsLimitationsClose}
      />
      <div className="nocoupon-container">
        <h1 className="head-title">Explore ways to save</h1>
        <p className="head-para">
          You have no offers currently available, but there are multiple ways to
          easily earn savings through your pharmacy activity.
        </p>
        <div className="container-one">
          <div className="main-sub-text">
            <h6 className="section-para">{getTextByDivision(responseApi)}</h6>
            <div className="termsLimitationsText termsLimit show-desktop">
              *Click here to read the offer{' '}
              <Button
                id="terms-and-limitations"
                className="click-here GA4_CTA"
                aria-label="terms and limitations"
                cta_type="Pharmacy Incentives"
                onClick={() => handleTermsLimitationsModal()}
                data-testid="termsLimitations"
              >
                Terms and Limitations
              </Button>
            </div>
          </div>
          <img src={NoCoupon1} alt="nocoupon" className="noCoupon_img" />
        </div>
        <div className="termsLimitationsText termsLimit hide-mobile">
          *Click here to read the offer{' '}
          <Button
            id="terms-and-limitations"
            className="click-here GA4_CTA"
            aria-label="terms and limitations"
            cta_type="Pharmacy Incentives"
            onClick={() => handleTermsLimitationsModal()}
            data-testid="termsLimitations"
          >
            Terms and Limitations
          </Button>
        </div>

        <div className="container-one">
          <div className="main-sub-text">
            <h6 className="section-para poppinsFont">
              Earn 10% off* your cart every time you receive a vaccine
            </h6>
            <p className="sub-text">*On entire purchase up to $200</p>
          </div>
          <img src={NoCoupon2} alt="nocoupon" className="noCoupon_img" />
        </div>
        <p className="sub-text-mobile">*On entire purchase up to $200</p>

        <h4 className="footer-text">Learn more about pharmacy</h4>
        <p className="footer-para">
          Let us be your all-in-one stop for prescriptions, vaccines and more!
        </p>
        <Button
          className="click-here GA4_CTA nocoupon-button"
          href={RPharmaLink}
          target="_blank"
        >
          Go to pharmacy
        </Button>
      </div>
    </>
  );
};
export default NoCoupons;
